import React, { useEffect, useState } from 'react';
import { Avatar, Button, Card, Divider, Form, Select, Space, notification } from 'antd';
import { useAuth } from '../../hooks/AuthProvider';
import { ChangePasswordModal } from './ChangePasswordModal';
import { authAxios } from '../../services/auth-axios';

export function UserInfo({ userId }) {
  const auth = useAuth();
  const [userData, setUserData] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState();
  const [updatingUserType, setUpdatingUserType] = useState(false);
  const isUser = localStorage.getItem('id') === userId;
  const roles = localStorage.getItem('roles');
  const isAdmin = roles && roles.includes('ADMIN');

  const fetchData = async () => {
    try {
      const response = await authAxios().get(`/users/${userId}`);
      setUserData(response.data);
      setSelectedUserType(response.data.userType);
    } catch (error) {
      console.error('Error fetching user data:', error);
      if (error.response && error.response.status === 401) {
        auth.logOut();
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [auth, userId]);

  const buildUserInitials = (name) => {
    if (!name) return '?';

    const names = name.split(' ');

    return names.map((n) => n[0]).join('');
  };

  const actions = [isUser && <ChangePasswordModal />];

  const handleUpdateUserType = async () => {
    if (!userData || !selectedUserType) return;

    setUpdatingUserType(true);
    try {
      await authAxios().put(`/users/${userId}`, {
        ...userData,
        userType: selectedUserType,
      });
      setUserData((prevUserData) => ({ ...prevUserData, userType: selectedUserType }));
      notification.success({ message: 'Tipo de usuário atualizado com sucesso!' });
    } catch (error) {
      console.error('Erro ao atualizar o tipo do usuário', error);
      notification.error({ message: 'Erro ao atualizar o tipo do usuário' });
      if (error.response && error.response.status === 401) {
        auth.logOut();
      }
    } finally {
      setUpdatingUserType(false);
    }
  };

  return (
    <Card title="Meus Dados" actions={actions}>
      <Card.Meta avatar={<Avatar size={40}>{buildUserInitials(userData?.name)}</Avatar>} title={userData?.name || '[Nome não informado]'} />

      <p>
        <strong>Email:</strong> {userData?.email}{' '}
      </p>
      <p>
        <strong>CPF:</strong> {userData?.cpf}{' '}
      </p>
      <p>
        <strong>Telefone:</strong> {userData?.phone}{' '}
      </p>
      <p>
        <strong>ID:</strong> {userData?.id} | <strong>Tipo:</strong> {userData?.userType}{' '}
      </p>

      {isAdmin && (
        <>
          <Divider />
          <Space direction="vertical" style={{ width: '100%' }}>
            <Form layout="vertical" onFinish={handleUpdateUserType} requiredMark={false}>
              <Form.Item label="Tipo do usuário" required>
                <Select
                  value={selectedUserType}
                  data-testid="user-type-select"
                  onChange={setSelectedUserType}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  options={[{ value: 'REGULAR', label: 'Regular' }, { value: 'ADMIN', label: 'Administrador' }]}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={updatingUserType} disabled={!selectedUserType} block>
                  Salvar tipo do usuário
                </Button>
              </Form.Item>
            </Form>
          </Space>
        </>
      )}
    </Card>
  );
}
